import { FC } from 'react'

import { cn } from '../utils'

export const Spinner: FC<{ size?: number | string; className?: string }> = ({
  size = 80,
  className,
}) => {
  return (
    <i className={cn('happitu-spinner', className)}>
      <svg viewBox="0 0 100 100" style={{ width: size, height: size }}>
        <circle
          cx="50"
          cy="50"
          r="46"
          strokeWidth="8"
          fill="none"
          strokeMiterlimit="10"
        ></circle>
      </svg>
    </i>
  )
}
